import { ChangeDetectorRef, Component, Input } from '@angular/core';
import {MatDialog} from '@angular/material/dialog';
import { TranslateService } from '@ngx-translate/core';
import {firstValueFrom} from 'rxjs';

import { first } from 'rxjs/operators';

import { BaseCtrlValueAccessorFormArrayComponent, FormManagerService } from '@sim/form';
import { ClassName } from '@sim/role';

import { SwalService } from '@atmi/core';
import { Movement, MovementMeta } from '@atmi/core/models';
import { MovementDialogComponent } from '@atmi/shared/movement-dialog/movement-dialog.component';

@Component({
  selector: 'app-movementss-manager',
  styleUrls: ['./movementss-manager.component.scss'],
  templateUrl: './movementss-manager.component.html',
})
export class MovementssManagerComponent extends BaseCtrlValueAccessorFormArrayComponent<Movement> {

  @Input() classNames: ClassName[] = [];

  get movements() {
    return this.value;
  }

  constructor(
    private readonly translate: TranslateService,
    private readonly dialog: MatDialog,
    private readonly swal: SwalService,
    private readonly formManager: FormManagerService,
    private readonly cd: ChangeDetectorRef,
  ) {
    super();
  }

  orderMovementHandler(items: Movement[]) {
    if (!this.form) {
      throw new Error('Cannot order without a form');
    }
    const form = this.form;
    const value: Movement[] = form.value;
    const pathcValue = value.map((_, i) => items[i]);

    this.form.controls.forEach((_, i) => {
      const control = this.formManager.makeForm(MovementMeta, pathcValue[i]);
      form.setControl(i, control);
    });

    this.cd.markForCheck();
  }

  async addMovementHandler() {
    const ref = this.dialog.open(MovementDialogComponent, { data: { classNames: this.classNames }, width: '784px' });
    const res: Movement | undefined = await firstValueFrom(ref.afterClosed().pipe(first()));

    if (res && this.form) {
      const group = this.formManager.makeForm(MovementMeta, res);
      if (this.form) {
        this.form.push(group);
      }

      this.cd.markForCheck();
    }
  }

  async editMovementHandler(movement: Movement, index: number) {
    const ref = this.dialog.open(MovementDialogComponent, { data: { movement, classNames: this.classNames }, width: '784px' });
    const res = await firstValueFrom(ref.afterClosed().pipe(first()));

    if (res && this.form) {
      const form = this.form;
      const value: Movement[] = form.value;
      const pathcValue = value.map((item, i) => i === index ? res : item);

      this.form.controls.forEach((_, i) => {
        const control = this.formManager.makeForm(MovementMeta, pathcValue[i]);
        form.setControl(i, control);
      });

      this.cd.markForCheck();
    }
  }

  async removeMovementHandler(index: number) {
    const res = await this.swal.showConfirm({
      text: this.translate.instant('Sei sicuro di voler rimuovere questo movimento?'),
      title: this.translate.instant('Rimozione movimento'),
    });

    if (res) {
      if (res && this.form) {
        this.form.removeAt(index);

        this.cd.markForCheck();
      }
    }
  }
}
